import axios, { AxiosResponse } from 'axios'

import { UserId, UserRead, UserWrite } from '@generated/types'

const BASE_URL = '/api/user'

export default {
  async fetchMe(): Promise<AxiosResponse<UserRead>> {
    return axios.get(`${BASE_URL}/profile/`)
  },

  async fetchMeOnboarding(userId: UserId, token: string): Promise<AxiosResponse<UserRead>> {
    return axios.get(`${BASE_URL}/${userId}/onboarding/?token=${token}`)
  },

  async login(username: string, password: string): Promise<AxiosResponse<UserRead>> {
    return axios.post(`${BASE_URL}/login/`, { username, password })
  },

  async setPassword(
    userId: UserId,
    token: string,
    password: string,
  ): Promise<AxiosResponse<UserRead>> {
    return axios.post(`${BASE_URL}/${userId}/set_password/?token=${token}`, { password })
  },

  async sendResetPasswordEmail(userId: UserId): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/${userId}/send_reset_password_email/`)
  },

  async resetPassword(email: string): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/reset_password/`, { email })
  },

  async fetchAll(): Promise<AxiosResponse<UserRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },

  async updateAll(data: UserWrite[]): Promise<AxiosResponse<UserRead[]>> {
    return axios.put(`${BASE_URL}/all/`, data)
  },
}
